import React from "react";

export const IconLink = (props) => {
    return <a className="icon-button" href={props.href}>
        <img src={props.image} alt={props.tooltip} />
    </a>
}
